export default class FacilityDocumentation {

  id = "";
  facilityId = "";

  type = "";
  fileName = "";
  start = "";
  end = "";

  constructor() {
  }
}
